import { createColumnHelper } from '@tanstack/react-table';

import { NodeRowData } from '../types';

export const columnHelper = createColumnHelper<NodeRowData>();
